import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import cx from 'classnames'

const buttonTextPrefix = 'scenes.Gnosus.components.Ribbon.components.ButtonsArray'

export default class NavigationItem extends Component {
    static propTypes = {
        block: PropTypes.string,
        expanded: PropTypes.bool,
        visibleBlocks: PropTypes.object,
        handleBtnClick: PropTypes.func.isRequired,
    }

    render() {
        const { block, visibleBlocks, expanded, handleBtnClick } = this.props

        const item = (
            <div
                className={cx('navigation-item', block, visibleBlocks[block] && 'highlight')}
                onClick={() => handleBtnClick(block)}
            >
                <div className={'item-label'}>
                    <FormattedMessage id={`${buttonTextPrefix}.report.reportBlocks.${block}`} />
                </div>
            </div>
        )

        if (expanded) return item

        return (
            <Tooltip
                id={`navigation-bar-item-tooltip-${block}`}
                width={'150px'}
                content={<FormattedMessage id={`${buttonTextPrefix}.report.reportBlocks.${block}`} />}
                key={`report-navigation-bar-item-${block}`}
                position={POSITION.LEFT}
                align={ALIGN.CENTER}
            >
                {item}
            </Tooltip>
        )
    }
}
